import React from 'react';
import {Skeleton} from '@zooplus/ui-components';

const SkeletonCustomerBalance = ({}): JSX.Element => {
  const GLOBAL_PREFIX: string = 'loy-bpo-balance-v2';
  return (
    <div className={`${GLOBAL_PREFIX}`}>
      <Skeleton style={{ borderRadius: '5px 50px 5px 5px', height:'73px'}} />
    </div>
  );
};
export default SkeletonCustomerBalance;
